(function() {
    'use strict';

    angular.module('app.cupones', []);
})();
